import React from "react";
import { Modal as AntModal } from "antd";
import classnames from "classnames";
import styles from "./modal.module.scss";
// import FullModal from "./full-modal";
import { Text, Icon } from "components/commons";

const Modal = ({
  active,
  children,
  title = "",
  customTitle,
  actionContent,
  close,
  noHeader,
  hidden,
  width,
  noCloseButton = false,
  paddingless = false,
  closable = false,
  fullModal = false,
  className,
  style
}) => {
  // if (fullModal) {
  //   return (
  //     <FullModal active={active} close={close}>
  //       {children}
  //     </FullModal>
  //   );
  // }
  return (
    <AntModal
      className={classnames(
        {
          "opacity-0": hidden,
          [`${styles.fullModal}`]: fullModal,
        },
        styles.container,
        className
      )}
      style={style}
      width={width}
      title={
        noHeader ? null : customTitle ? (
          // <div className={"flex items-center"}>
          <div className={"flex items-center justify-between"}>
            {customTitle}
            {!noCloseButton && (
              <Icon
                className="outline-none text-xl text-gray hover:text-gray cursor-pointer"
                name="remove"
                onClick={() => {
                  close();
                }}
              />
            )}
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <Text modalTitle>{title}</Text>
            {!noCloseButton && (
              <Icon
                className="outline-none text-xl text-gray hover:text-gray cursor-pointer"
                name="remove"
                onClick={() => {
                  close();
                }}
              />
            )}
          </div>
        )
      }
      visible={active}
      footer={null}
      bodyStyle={{ padding: 0 }}
      maskClosable={closable}
      closable={false}
      onCancel={closable ? () => close() : null}
    >
      <div
        className={classnames({
          "pb-md": actionContent,
          "px-md": !paddingless,
          "bg-white": fullModal,
        })}
      >
        {children}
      </div>
      {actionContent}
    </AntModal>
  );
};

export default Modal;
